import { Injectable, inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { TimelineTimeframe } from '@wilson/interfaces';
import { GanttDimensionDataSourceService } from '@wilson/shift-timeline/assignments-gantt-chart';
import {
  ShiftTimelineDataState,
  ShiftTimelineState,
} from '@wilson/shift-timeline/state';
import { Observable } from 'rxjs';

@Injectable()
export class ShiftTimelineGanttDimensionDataSourceService extends GanttDimensionDataSourceService {
  private store = inject(Store);

  override frameLengthStream(): Observable<number> {
    return this.store.select(ShiftTimelineState.frameLength);
  }

  override timeframeStream(): Observable<TimelineTimeframe> {
    return this.store.select(ShiftTimelineDataState.timeframe);
  }

  override visibleDaysRangeStream(): Observable<TimelineTimeframe> {
    return this.store.select(ShiftTimelineDataState.visibleDateRange);
  }
}
